import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Rest from '../services/rest';
import { IRestParams } from '../types/rest';

const useRest = (showErrorMessage = true) => {
    const rest = new Rest();

    const navigate = useNavigate();

    const fetch = async (params: IRestParams) => {
        const result = await rest.fetch(params);
        if (result.isError) {
            if (result.response?.data?.error && typeof result.response?.data?.errorText === 'string') {
                if (showErrorMessage) {
                    Swal.fire({
                        title: result.response?.data?.errorText,
                        icon: 'error',
                    });
                }
            }
            if (result.response?.status === 401) {
                navigate('/login');
            }
        }
        return result;
    };

    return {
        fetch,
    };
};

export default useRest;
